import { createSelector } from '@reduxjs/toolkit';
import { RatingState } from '../types/ratingTypes';
import { RootState } from '@/store/store';
import { useSelector } from 'react-redux';

export const selectRating = (state: RootState): RatingState => state.testRating;

export const selectCurrentRating = createSelector(
	[selectRating],
	(ratingState) => ratingState.rating
);

export const selectRatingPercent = createSelector(
	[selectRating],
	(ratingState) => ratingState.ratingPercent
);

export const selectSelectedRating = createSelector(
	[selectRating],
	(ratingState) => ratingState.selectedRating
);

export const checkIsVoted = createSelector(
	[selectRating],
	(ratingState) => ratingState.isUsrVoted
);

export const checkIsRatingSaved = createSelector(
	[selectRating],
	(ratingState) => ratingState.saved
);


export const checkIsOwnAttempt = createSelector(
	[selectRating],
	(ratingState) => ratingState.isOwnAttempt
);
